import React from 'react'

function MessageLoader() {
  return (
 <div className="message_is_loading">
      <div className="loader">
    <div className="dot"></div>
</div>
<div className="loader">
    <div className="dot"></div>
</div>
<div className="loader">
    <div className="dot"></div>
</div>
<div className="loader">
    <div className="dot"></div>
</div>
<div className="loader">
    <div className="dot"></div>
</div>
<div className="loader">
    <div className="dot"></div>
</div>

 </div>
  )
}

export default MessageLoader